// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3HGV9","navigationTip":"Footer_navigationTip__3t-tx","navigationTipIcon":"Footer_navigationTipIcon__2Gj64"};